import axios from "axios";

const CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutes cache to balance freshness vs API calls

const getDefaultState = () => ({
	blockedNumbers: [],
	lastFetchTime: null,
	loading: false
});

export default {
	namespaced: true,

	state: getDefaultState,

	getters: {
		blockedNumbers: (state) => state.blockedNumbers,
		isBlocked: (state) => (phoneNumber) => {
			if (!phoneNumber || !state.blockedNumbers.length) return false;
			return state.blockedNumbers.includes(phoneNumber);
		},
		loading: (state) => state.loading
	},

	mutations: {
		setBlockedNumbers: (state, numbers) => {
			state.blockedNumbers = numbers;
			state.lastFetchTime = Date.now();
		},
		setLoading: (state, loading) => {
			state.loading = loading;
		},
		addBlockedNumber: (state, phone) => {
			if (!state.blockedNumbers.includes(phone)) {
				state.blockedNumbers.push(phone);
			}
		},
		removeBlockedNumber: (state, phone) => {
			state.blockedNumbers = state.blockedNumbers.filter(p => p !== phone);
		},
		resetState: (state) => {
			Object.assign(state, getDefaultState());
		}
	},

	actions: {
		async fetchBlockedNumbers({ commit, state }, { force = false } = {}) {
			// Skip if recently fetched and not forcing refresh
			const now = Date.now();

			if (!force && state.lastFetchTime && (now - state.lastFetchTime) < CACHE_DURATION_MS) {
				return state.blockedNumbers;
			}

			commit("setLoading", true);
			try {
				const response = await axios.get("/devops/blocked");
				const numbers = response.data || [];

				commit("setBlockedNumbers", numbers);
				return numbers;
			} catch (error) {
				console.error("Error fetching blocked numbers:", error);
				return state.blockedNumbers;
			} finally {
				commit("setLoading", false);
			}
		},

		async blockNumber({ commit, dispatch }, phone) {
			await axios.post("/devops/blocked", { phone });
			commit("addBlockedNumber", phone);
			// Force refresh to sync with server (in case other users blocked numbers)
			await dispatch("fetchBlockedNumbers", { force: true });
		},

		async unblockNumber({ commit, dispatch }, phone) {
			await axios.delete(`/devops/blocked/${encodeURIComponent(phone)}`);
			commit("removeBlockedNumber", phone);
			// Force refresh to sync with server
			await dispatch("fetchBlockedNumbers", { force: true });
		},

		// Call this to ensure we have fresh data when switching conversations
		async refresh({ dispatch }) {
			await dispatch("fetchBlockedNumbers", { force: false });
		}
	},
	init({ watch, login, commit }) {
		watch(
			() => login.profile?.id,
			(newId, oldId) => {
				if (newId === oldId) return;
				if (!newId && oldId) {
					commit("resetState");
				}
			}
		);
	}
};
